import { MediaManagerTemplateGql } from 'modules/manager/domain/graphql/media-manager-templates';

/** GraphQL `MediaManagerTemplateGroup` — camelCase. */
export interface MediaManagerTemplateGroupGql {
  id: number;
  name: string;
  tournamentId: number | null;
  templatesCount: number;
  templates?: MediaManagerTemplateGql[] | null;
  createdAt: string;
  updatedAt: string;
}

const GROUP_LIST_FIELDS = `
  id
  name
  tournamentId
  templatesCount
  createdAt
  updatedAt
`;

const GROUP_DETAIL_FIELDS = `
  ${GROUP_LIST_FIELDS}
  templates {
    id
    name
    objects
    version
    order
    width
    height
    tournamentId
    templateGroupId
    sportType
    templateType
    templateSubtypes
    matchLayout
    playerRanking
    createdAt
    updatedAt
  }
`;

export const MEDIA_MANAGER_TEMPLATE_GROUPS_QUERY = `#graphql
  query mediaManagerTemplateGroups($tournamentId: Int!) {
    mediaManagerTemplateGroups(tournamentId: $tournamentId) {
      ${GROUP_LIST_FIELDS}
    }
  }
`;

export const MEDIA_MANAGER_PRESET_TEMPLATE_GROUPS_QUERY = `#graphql
  query mediaManagerPresetTemplateGroups {
    mediaManagerPresetTemplateGroups {
      ${GROUP_LIST_FIELDS}
    }
  }
`;

export const MEDIA_MANAGER_TEMPLATE_GROUP_QUERY = `#graphql
  query mediaManagerTemplateGroup($id: Int!) {
    mediaManagerTemplateGroup(id: $id) {
      ${GROUP_DETAIL_FIELDS}
    }
  }
`;

export const CREATE_MEDIA_MANAGER_TEMPLATE_GROUP_MUTATION = `#graphql
  mutation createMediaManagerTemplateGroup($input: CreateMediaManagerTemplateGroupInput!) {
    createMediaManagerTemplateGroup(input: $input) {
      ${GROUP_LIST_FIELDS}
    }
  }
`;

export const UPDATE_MEDIA_MANAGER_TEMPLATE_GROUP_MUTATION = `#graphql
  mutation updateMediaManagerTemplateGroup($input: UpdateMediaManagerTemplateGroupInput!) {
    updateMediaManagerTemplateGroup(input: $input) {
      ${GROUP_LIST_FIELDS}
    }
  }
`;

export const DELETE_MEDIA_MANAGER_TEMPLATE_GROUP_MUTATION = `#graphql
  mutation deleteMediaManagerTemplateGroup($id: Int!, $deleteTemplates: Boolean) {
    deleteMediaManagerTemplateGroup(id: $id, deleteTemplates: $deleteTemplates) {
      status
    }
  }
`;

export const COPY_MEDIA_MANAGER_TEMPLATE_GROUP_MUTATION = `#graphql
  mutation copyMediaManagerTemplateGroup($input: CopyMediaManagerTemplateGroupInput!) {
    copyMediaManagerTemplateGroup(input: $input) {
      ${GROUP_DETAIL_FIELDS}
    }
  }
`;
